<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row" v-if="profile">
        <div class="col-12">
          <stats-card>
            <div slot="header" class="icon-warning" style="text-align: left;">
              <i class="nc-icon nc-circle-09 text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">{{profile.name + ' ' + profile.last_name}}</p>
              <h4 class="card-title">{{roleLabel}}</h4>
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-circle-09 text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Kayıtlı Toplam Kullanıcı Sayısı</p>
              <h4 class="card-title">{{reportUserCount}}</h4>
            </div>
            <!--<div slot="footer">
              <i class="fa fa-refresh"></i>Updated now
            </div>-->
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-money-coins text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Kumbara Atanmış Kişi Sayısı</p>
              <h4 class="card-title">{{reportUserAssignedMoneybox}}</h4>
            </div>
            <!--<div slot="footer">
              <i class="fa fa-refresh"></i>Last day
            </div>-->
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-money-coins text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Kumbara Atanmamış Kişi Sayısı</p>
              <h4 class="card-title">{{reportUserUnAssignedMoneybox}}</h4>
            </div>
            <!--<div slot="footer">
              <i class="fa fa-refresh"></i>Last day
            </div>-->
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-vector text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Toplam Kumbara Sayısı</p>
              <h4 class="card-title">{{reportMoneyBoxCount}}</h4>
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row" v-if="overdueCount > 0">
        <div class="col-12">
          <a href="#/admin/reports" style="text-decoration: none;">
            <stats-card>
              <div slot="header" class="icon-danger">
                <i class="nc-icon nc-bell-55 text-danger"></i>
              </div>
              <div slot="content">
                <p class="card-category">Dikkat Gerektiren Durum</p>
                <h4 class="card-title">{{ overdueCount }} kumbara gecikmiş — detaylar için tıklayın</h4>
              </div>
            </stats-card>
          </a>
        </div>
      </div>
      <div class="row">
        <!--<div class="col-md-8">
          <chart-card :chart-data="lineChart.data"
                      :chart-options="lineChart.options"
                      :responsive-options="lineChart.responsiveOptions">
            <template slot="header">
              <h4 class="card-title">Kullanıcı Davranışı</h4>
              <p class="card-category">24 saatlik</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> açıldı
                <i class="fa fa-circle text-danger"></i> tıklandı
                <i class="fa fa-circle text-warning"></i> tıklanma süresi
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated 3 minutes ago
              </div>
            </template>
          </chart-card>
        </div>-->

        <div class="col-md-4">
          <chart-card v-if="moneyboxUnloadStateData.series" :chart-data="moneyboxUnloadStateData" chart-type="Pie">
            <template slot="header">
              <h4 class="card-title">Kumbara Boşaltma Raporu</h4>
              <!--<p class="card-category">Last Campaign Performance</p>-->
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> boşaltılmış
                <i class="fa fa-circle text-danger"></i> boşaltılma zamanı geçmiş
                <i class="fa fa-circle text-warning"></i> henüz zamanı gelmemiş
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-clock-o"></i> Anlık olarak raporlanmıştır.
              </div>
            </template>
          </chart-card>
        </div>
      </div>

      <!--<div class="row">
        <div class="col-md-12">
          <chart-card
            :chart-data="barChart.data"
            :chart-options="barChart.options"
            :chart-responsive-options="barChart.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">2023 Analiz Test</h4>
              <p class="card-category">Buraya istediğiniz bir analiz diagramı gelebilir</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Test 1
                <i class="fa fa-circle text-danger"></i> Test 2
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-check"></i> Anlık olarak raporlanmıştır.
              </div>
            </template>
          </chart-card>
        </div>
      </div>-->
       <div class="row">
        <div class="col-md-12">
          <div class="card card-map">
            <div class="card-header">
              <div>
                <h4 class="card-title">Kumbara Haritası</h4>
              </div>
            </div>
            <div class="card-body">
              <app-maps></app-maps>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import AppMaps from './Maps.vue'
  import roleList from '../plugins/roles.json'
  import {mapState, mapActions, mapGetters} from "vuex"
  export default {
    mounted(){
      const self = this
      self.$store.dispatch("Reports/requestReportBasic")
      self.$store.dispatch("Reports/requestReportMoneyboxUnloadState")
      if (self.profile && self.profile.roles[0] === 'segmentAdmin') {
        self.$store.dispatch("Segments/requestSegmentMyPath").then((path) => {
          self.mySegmentPath = path || []
        })
      }
    },
    methods: {
      
    },
    computed: {
      roles(){
        return roleList
      },
      profile(){
        return JSON.parse(localStorage.getItem("user"));
      },
      roleLabel(){
        // A generic "Segment Admin" doesn't say whether this person manages
        // a Şube, Bölge or Merkez - use the specific segment type name from
        // their location in the hierarchy instead.
        if (this.profile.roles[0] === 'segmentAdmin' && this.mySegmentPath.length) {
          const own = this.mySegmentPath[this.mySegmentPath.length - 1]
          return own.segment_type_name + ' Yöneticisi'
        }
        return roleList.find(item => item.key == this.profile.roles[0]).value
      },
      ...mapState({
        report_basic: state => state.Reports.report_basic,
        report_moneybox_unload_state: state => state.Reports.report_moneybox_unload_state
      }),
      overdueCount() {
        if (!this.report_moneybox_unload_state.length) return 0
        return this.report_moneybox_unload_state.filter(
          (item) => _app.$getDiffIntervalMoneyboxUnload(item) === 'red'
        ).length
      },
      moneyboxUnloadStateData() {
        if(!this.report_moneybox_unload_state.length) return {}

        var data = []
        this.report_moneybox_unload_state.forEach((item) =>{

          data.push(_app.$getDiffIntervalMoneyboxUnload(item))

        })

        var red_count = data.filter(item =>item == 'red').length
        var green_count = data.filter(item =>item == 'green').length
        var yellow_count = data.filter(item =>item == 'yellow').length

        var red_percent = parseFloat((100*red_count)/data.length).toFixed(2)
        var green_percent = parseFloat((100*green_count)/data.length).toFixed(2)
        var yellow_percent = parseFloat((100*yellow_count)/data.length).toFixed(2)

        var p_data = {
          labels: [green_percent+'%', red_percent+'%', yellow_percent+'%'],
          series: [green_percent, red_percent, yellow_percent]
        }

        return p_data
      },
      reportUserCount(){
        if(this.report_basic.length>0){
          return this.report_basic.find(item => item.key == 'user_count').count
        }
        return 0
      },
      reportUserAssignedMoneybox(){
        if(this.report_basic.length>0){
          return this.report_basic.find(item => item.key == 'user_assigned_moneybox_count').count
        }
        return 0
      },
      reportUserUnAssignedMoneybox(){
        return this.reportMoneyBoxCount - this.reportUserAssignedMoneybox;
      },
      reportMoneyBoxCount(){
        if(this.report_basic.length>0){
          return this.report_basic.find(item => item.key == 'moneybox_count').count
        }
        return 0
      },
    },
    components: {
      LTable,
      ChartCard,
      StatsCard,
      AppMaps
    },
    data () {
      return {
        mySegmentPath: [],
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        pieChart: {
          data: {
            labels: ['41%', '20%', '40%'],
            series: [41, 20, 40]
          }
        },
        lineChart: {
          data: {
            labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
            series: [
              [287, 385, 490, 492, 554, 586, 698, 695],
              [67, 152, 143, 240, 287, 335, 435, 437],
              [23, 113, 67, 108, 190, 239, 307, 308]
            ]
          },
          options: {
            low: 0,
            high: 800,
            showArea: false,
            height: '245px',
            axisX: {
              showGrid: false
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        barChart: {
          data: {
            labels: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
              [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
            ]
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        tableData: {
          data: [
            {title: 'Sign contract for "What are conference organizers afraid of?"', checked: false},
            {title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true},
            {
              title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              checked: true
            },
            {title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false},
            {title: 'Read "Following makes Medium better"', checked: false},
            {title: 'Unfollow 5 enemies from twitter', checked: false}
          ]
        }
      }
    }
  }
</script>
<style>

</style>
